module.exports = __webpack_public_path__ + "img/piston-pull.58b481a7.png";